import { BRIGHT_GREEN_COLOR, COLORS, SUCCESS_GREEN_COLOR } from 'consts/colors'

export const getRatingColor = (score: number): string => {
  if (score >= 8) return SUCCESS_GREEN_COLOR
  if (score >= 7) return BRIGHT_GREEN_COLOR
  if (score >= 5) return COLORS.warningColor
  return COLORS.accentRed
}
